var $c887e8e007a7b060$exports = {};
(()=>{
    function toggleLightnessMode() {
        document.documentElement.classList.toggle("dark");
        localStorage.getItem("color-theme") === "dark" ? localStorage.setItem("color-theme", "light") : localStorage.setItem("color-theme", "dark");
    }
    const darkModeCheckboxes = document.querySelectorAll('.slider input[type="checkbox"');
    darkModeCheckboxes.forEach((darkModeCheckbox)=>{
        darkModeCheckbox.addEventListener("click", toggleLightnessMode);
        darkModeCheckboxes.forEach((btn)=>btn.addEventListener("keyup", function(event) {
                if ([
                    13,
                    32
                ].includes(event.keyCode)) toggleLightnessMode();
            }));
    });
})();


//# sourceMappingURL=index.c083e82a.js.map
